/**
 * When a scheduled game is close enough to its start time that the scoreboard
 * should offer to move it to "In Progress".
 *
 * The window opens before the start time because a scorekeeper sets up early,
 * and stays open well past it because games start late and run long. Outside it
 * the prompt would be noise — opening next week's game to check a roster should
 * not ask whether it is being played.
 */
export const LIVE_WINDOW_BEFORE_MS = 30 * 60 * 1000;
export const LIVE_WINDOW_AFTER_MS = 4 * 60 * 60 * 1000;

/**
 * A game's `date` arrives from the API as a floating wall-clock stamp with no
 * zone ("2026-10-13T19:00:00"), which the browser reads in its own zone — the
 * rink's, for the scorekeeper standing in it.
 */
export function isNearStartTime(
  gameDate: string | null | undefined,
  now: number = Date.now(),
): boolean {
  if (!gameDate) return false;

  const start = new Date(gameDate).getTime();
  if (Number.isNaN(start)) return false;

  return (
    now >= start - LIVE_WINDOW_BEFORE_MS && now <= start + LIVE_WINDOW_AFTER_MS
  );
}
